// extracted by mini-css-extract-plugin
export default {"productsCartBox":"styles_productsCartBox__zKOmz"};